/** SA-1092 §4.1: the Open tab's sort options and default per channel chip,
 * worded once. The server values: `recent` (newest activity / message),
 * `oldest` (by activity), `unread`, `waiting` (group threads only). A chat
 * console (R2: Jaso's bar byte for byte) keeps today's three labels under
 * every chip. */
import type { ShapeKind } from './inboxShape'

export interface SortOption { value: string; label: string }

const TODAY: SortOption[] = [
  { value: 'recent', label: 'Newest first' }, { value: 'oldest', label: 'Oldest first' }, { value: 'unread', label: 'Unread first' },
]

export function sortOptions(channel: string | null, kind: ShapeKind = 'desk'): SortOption[] {
  if (kind === 'console' || kind === 'none' || kind === 'loading') return TODAY
  if (channel === 'email') {
    return [{ value: 'recent', label: 'Newest message' }, { value: 'oldest', label: 'Oldest message' }, { value: 'unread', label: 'Unread first' }]
  }
  if (channel === 'whatsapp-group') {
    return [{ value: 'waiting', label: 'Most waiting first' }, { value: 'recent', label: 'Newest activity' }]
  }
  return [{ value: 'recent', label: 'Newest activity' }, { value: 'oldest', label: 'Oldest activity' }, { value: 'unread', label: 'Unread first' }]
}

export function defaultSort(channel: string | null, kind: ShapeKind = 'desk'): string {
  return sortOptions(channel, kind)[0].value
}

/** The option SET a chip offers, as one key: a chip change resets the sort
 * only when this changes (Email ↔ WhatsApp group), never on a console. */
export function sortValues(channel: string | null, kind: ShapeKind = 'desk'): string {
  return sortOptions(channel, kind).map((o) => o.value).join(',')
}
